module.exports = __webpack_public_path__ + "img/KKP.8836260b.png";